const headerAf = {
  brand: 'ګرامین بازار',
  top: {
    bazarList: 'بازارونه',
    help: 'مرسته',
    contact: 'اړیکه',
  },
  nav: {
    dailyBazar: 'روزانه بازار',
    medicineBazar: 'دواګانو بازار',
    foodBazar: 'تازه خواړه',
    grains: 'غله جات',
    nationalBazar: 'ملکی',
    garmentsBazar: 'جامې',
    cosmeticsBazar: 'کاسمیټیک',
    bookBazar: 'کتابونه',
    nurseryBazar: 'نرسري',
    electronicsBazar: 'برقی توکي',
    chemicalBazar: 'کیمیاوي توکي',
    hardwareBazar: 'هارډویر',
    serviceBazar: 'خدمتونه',
    feedBazar: 'د حیواناتو خواړه',
  },
  search: {
    placeholder: 'تاسو څه پلوري؟'
  },
  drawer: {
    home: 'کور',
    dailyBazar: 'روزانه بازار',
    medicineBazar: 'دواګانو بازار',
    grains: 'غله جات بازار',
    nationalBazar: 'ملکی بازار',
    foodBazar: 'تازه خواړه',
    bookBazar: 'کتابونه بازار',
    nurseryBazar: 'نرسري بازار',
    garmentsBazar: 'جامې بازار',
    electronicsBazar: 'برقی توکي بازار',
    chemicalBazar: 'کیمیاوي توکي بازار',
    hardwareBazar: 'هارډویر بازار',
    cosmeticsBazar: 'کاسمیټیک بازار',
    serviceBazar: 'خدمتونه بازار',
    feedBazar: 'د حیواناتو خواړه بازار',
  },
  profileMenu: {
    login: 'ننوتل',
    register: 'ثبتول',
    myAccount: 'زما حساب',
    storeDashboard: 'د پلورنځي ډاشبورډ',
    adminDashboard: 'د ادمین ډاشبورډ',
  },
};

export default headerAf;
